import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Headers, } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class MainserviceService {
  private base_url_dev = "http://localhost:8000/api/v1/"
  private base_url_prod = "https://windaapi.herokuapp.com/api/v1/"
  private base_url
  constructor(
    private http: Http

  ) {
    this.base_url = this.base_url_prod
  }
  getPromoCodes() {
    return this.http.get(this.base_url + "promocodes/")
      .map(resp => resp.json())
      .catch(this.error)
  }
  getClues() {
    return this.http.get(this.base_url + "clues/")
      .map(resp => resp.json())
      .catch(this.error)
  }
  getGamePromocodes(id:number){
    return this.http.get(this.base_url + "statistics/promocodes/game?game="+id)
    .map(resp => resp.json())
    .catch(this.error)
  }

  getShopPromocodes(id:number){
    return this.http.get(this.base_url + "promocodes/?shop="+id)
    .map(resp => resp.json())
    .catch(this.error)
  }
  getShopPromoStats(id:number){
    return this.http.get(this.base_url + "statistics/promocodes/shop?shop="+id)
    .map(resp => resp.json())
    .catch(this.error)
  }
  getGameStats(id:number){
    return this.http.get(this.base_url + "statistics/plays/game?game="+id)
    .map(resp => resp.json())
    .catch(this.error)
  }
  getClueStats(id:number){
    return this.http.get(this.base_url + "statistics/plays/shop?shop="+id)
    .map(resp => resp.json())
    .catch(this.error)
  }
  getShopClueStats(id:number){
    return this.http.get(this.base_url + "statistics/plays/daily?shop="+id)
    .map(resp => resp.json())
    .catch(this.error)
  }

  getAllStatistics() {
    return this.http.get(this.base_url + "statistics/")
      .map(resp => resp.json())
      .catch(this.error)
  }

  getStatistics(name,type) {
    return this.http.get(this.base_url + "statistics/"+name+"/" + type)
      .map(resp => resp.json())
      .catch(this.error);
  }
    getUsers() {
    return this.http.get(this.base_url + "clients/" )
      .map(resp => resp.json())
      .catch(this.error)
  }

  getUser(id: number){
    return this.getUsers()
    .map(users => users.find(user => user.id === id));
  }

  getUser2(num: number){
    return this.getUsers()
    .map(users => users.find(user => user.user === num));
  }
  
  getShops() {
    return this.http.get(this.base_url + "shops/" )
      .map(resp => resp.json())
      .catch(this.error);
  }
  getShop(id:number){
    return this.getShops()
    .map(shops => shops.find(shop=> shop.id === id));
  }
  getMalls() {
    return this.http.get(this.base_url + "malls/" )
      .map(resp => resp.json())
      .catch(this.error)
  }
  getMall(id:number){
    return this.getMalls()
    .map(malls => malls.find(mall => mall.id === id));
  }
  
  getGames() {
    return this.http.get(this.base_url + "games/" )
      .map(resp => resp.json())
      .catch(this.error)

  }
  getGame(id: number){
    return this.getGames()
    .map(games => games.find(game => game.id === id));
  }
 getLB(id:number){
  return this.http.get(this.base_url + "statistics/leaderboard/"+id )
  .map(resp => resp.json())
  .catch(this.error)
 }
 getLeaderboard(){
  return this.http.get(this.base_url + "statistics/leaderboard/" )
  .map(resp => resp.json())
  .catch(this.error)
 }
 getLeaderStat(user:number){
   return this.getLeaderboard()
   .map(leaders => leaders.find(leader => leader.user === user) )
 }
 


  private error(error: any) {
    //console.log("This is ", error);
    if (!error.url) {
      return Observable.throw("No internet Connection ");
    }
    else if (error.status == 401) {
      return Observable.throw("Token Expired");
    }
    else {
      return Observable.throw(error.json() || "Error ")
    }
    //  this.error(error);
    // this.presentAlert("Observable Api Error", JSON.stringify(error));

  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mainservice.service.ts